import { COUNTRY_CODES } from '../constants/enums.js'
export default class LocaleFunctions {

    static getLocaleForCountry(countryCode, defaultLocale = 'sv-SE') {

        const localeMap = {
            'se': 'sv-SE',
            'no': 'no-NO',
            'dk': 'da-DK'
        };

        return localeMap[countryCode.toLowerCase()] || defaultLocale;
    };
}
